import React, { useState, useEffect, Fragment, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setTheQueryTrackingrecordgetListRetrieveActions,
  setTheTrackingEditionsActions,
  settheQueryQuestionActions, ////category--------actions
  setTheTrackingCreateActions, ///---create ---tickets
  settheQuerySubQuestionActions,
} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { Label } from "recharts";
import Select from "react-select";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Button from "@mui/material/Button";
import { colors } from "@mui/material";
import { data } from "jquery";
import { toast } from "react-toastify";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import PlusIcon from "../../../Assets/AppComponent/Asset 9.svg"
import minus from "../../../Assets/AppComponent/Asset 10.svg"
import { PresentUrl } from "../../../text/apidata";
import axios from "axios";
import { store } from "../../../Redux/Store";


const TrackingRecordApprove = (props) => {
  const {
    currentPage,
    setShow,
    show,
    EditID,
    selectVal,
    white_collar,
    // Datestate,
    from_date,
    to_date,
    ForReadOnly,
    search,
  } = props;
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const [descpErr, setdeserr] = useState("");
  const initialState = {
    from_user: "",
    user_id: "",
    category_id: "",
    user_name: "",
    description: "",
    status: "Open",
    send_type: 0,
  };
  const [Data, setDatas] = useState(initialState);
  const formDatas = new FormData();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const sateusers = useSelector((sateusers) => sateusers);
  const [imageFiles, setImageFiles] = useState()

  const [SubRoleList, setSubRoleList] = useState();
  const [Category, setCategory] = useState();
  const [cateid, setCateid] = useState({ id: "" });
  const [categoryvalue, setCategoryvalue] = useState();
  const [Ticketsend, setTicket] = useState({ devTeam: false, UdsTeam: true });
  const [categoryErr, setCategoryErr] = useState("");
  const [statuslist, setStatuslist] = useState();

  const [subCateGorys, setSubCateGorys] = useState();

  const [subCateGorysvalue, setSubCateGorysvalue] = useState();

  const [inputFields, setInputFields] = useState([
    {
      Files: "",
      file: "",
    },
  ]);
  const [PresentUrls, setPresentUrls] = useState([])
  const [url, setUrl] = useState();
  const [alert, setalert] = useState(false);
  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
  const [imgsrc, setImgsrc] = useState();
  const imgRef = useRef(null);
  const [crop, setCrop] = useState();

  const fixedCropSize = { width: 300, height: 200 };

  const [imageFileChange, setImageFileChange] = useState([
    false,
    false,
    false,
    false,
  ]);
  const [updateImage, setUpdateImage] = useState([false, false, false, false]);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [images, setImages] = useState([]);
  const [imagesFile, setImagesFile] = useState([]);
  const [forindex, setforindex] = useState();
  const [updated, setupdatefile] = useState(false);
  const fileInputRef = useRef();
  const [documentPassed, setdocumentPassed] = useState(false)
  useEffect(() => {
    if (EditID != "") {
      const payload = {
        EditID: EditID,
      };
      dispatch(setTheQueryTrackingrecordgetListRetrieveActions(payload));
    }
  }, []);

  useEffect(() => {
    if (EditID == "") {
      const payload = {
        search: "",
        page_size: 20,
        page: 1,
      };
      dispatch(settheQueryQuestionActions(payload));
    }
  }, []);

  const updateAvatar = (imgSrc) => {
    fileInputRef.current = imgSrc;
  };

  useEffect(() => {
    if (EditID == "" && cateid.id != "") {
      const payload = {
        search: "",
        page_size: 30,
        page: 1,
        parent: cateid.id,
      };
      dispatch(settheQuerySubQuestionActions(payload));
    }
  }, [cateid]);

  const handleTicketChanges = (e, name, value, values) => {
    console.log(value, values, "tickets");
    setTicket({
      ...Ticketsend,
      devTeam: value,
      UdsTeam: values,
    });
  };

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  useEffect(() => {
    if (
      EditID != "" &&
      state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve !=
      undefined
      && state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve
        .user_id != undefined && state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve
          .user_id != null
    ) {
      const dateString =
        state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve
          .applied_date;
      const dateObject = new Date(dateString);
      const hours = dateObject.getHours();
      const minutes = dateObject.getMinutes();
      const amOrPm = hours >= 12 ? "PM" : "AM";
      const twelveHourFormat = hours % 12 || 12;
      const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;
      setDatas({
        ...Data,
        status:
          state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve
            .status,
        from_user:
          state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve
            .from_user,

        user_name:
          state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve
            .user_id.first_name,
        category_id:
          state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve
            .category_id != null
            ? state.QueryTrackingrecordgetListRetrieve
              .QueryTrackingrecordRetrieve.category_id.name
            : "",
        send_type: state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve.send_type,
        description:
          state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve.from_support,
      });
      setTicket({
        ...Ticketsend,
        devTeam: state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve.send_type == 1 ? true : false,
        UdsTeam: state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve.send_type == 0 ? true : false,
      });
      setStatuslist({
        value:
          state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve
            .status,
        label: capitalizeFirstLetter(
          state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve
            .status
        ),
      });

      if (state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve.support_documents != null &&
        state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve.support_documents != undefined
      ) {
        state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve.support_documents.map((item, index) => {
          console.log(state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve, "28130192QueryTrackingrecordRetrieve", item);
          if (item != undefined && item != null) {
            setImagesFile(prevUrls => {
              const updatedUrls = [...prevUrls];
              updatedUrls[index] = item.media_url;
              return updatedUrls;

            });
            setforindex(3)
            // const values = [...inputFields]; ///----result
            // values[index].Files = item.media_url; // we have a field for croppedImageData

            // setInputFields(values);

            setInputFields(prevFields => {
              const values = [...prevFields];

              if (!values[index]) {
                values[index] = {};
              }
              values[index].Files = item.media_url;
              return values;
            });

          }
        })
      }

    }
  }, [state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve]);

  const HandleChanges = (e) => {
    const { name, value } = e.target;
    setDatas({
      ...Data,
      [name]: value,
    });
  };

  const HandleDecriptions = (e) => {
    setDatas({
      ...Data,
      description: e.target.value,
    });
    setdeserr("");
  };

  const handleClose = () => {
    setShow(false);
  };

  //------To ----Apply for ----the -----ticket

  useEffect(() => {
    if (EditID == "" && sateusers.users.UserData.data != undefined) {
    }
    if (sateusers.users.UserData.session) {
      // console.log(sateusers.users.UserData.data, "UserDsdsdasdata");
      if (
        sateusers.users.UserData.data != undefined &&
        sateusers.users.UserData.data != null
      ) {
        setSubRoleList({
          value: sateusers.users.UserData.data.id,
          label: sateusers.users.UserData.data.first_name,
        });

        setDatas({
          ...Data,

          user_id: sateusers.users.UserData.data.id,
        });
      }
    }
  }, [sateusers.users]);
  console.log(Category, "23974Category");

  ///----categorys---
  ///----- to ---get the---categorys
  useEffect(() => {
    if (EditID == "" && state.QueryQuetionsDatas.QueryQuestionsDatas) {
      const Object = [];
      state.QueryQuetionsDatas.QueryQuestionsDatas.forEach((element) => {
        Object.push({ label: element.name, value: element.id });
      });
      setCategory(Object);
    }
  }, [state.QueryQuetionsDatas.QueryQuestionsDatas]);
  ///----- to ---get the---categorys
  useEffect(() => {
    if (state.QuerySubQuetionsDatas.QuerySubQuestionsDatas) {
      if (cateid.id == cateid.id) {
        const Object = [];
        state.QuerySubQuetionsDatas.QuerySubQuestionsDatas.forEach(
          (element) => {
            Object.push({ label: element.name, value: element.id });
          }
        );

        setSubCateGorys(Object);
      }
    }
  }, [state.QuerySubQuetionsDatas.QuerySubQuestionsDatas]);

  const handleFiles = (e) => {
    selectedImage(e);
  };
  console.log(from_date,
    to_date,
    "from_date asd"
  );


  const HandleClick = () => {
    var a = 0;

    const fetchUploadFiles = async () => {
      await Promise.all(PresentUrls.map(async (item, index) => {
        try {
          if (item != undefined && item != null) {

            const response = await fetch(item.url, {
              method: 'PUT',
              headers: {
                'Content-Type': item.type,
                "x-amz-acl": "public-read"
              },
              body: item.putfiles,
            });

            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }

            if (EditID != "" && PresentUrls.length == index + 1) {

              let EditedDATAPresent = {
                status: Data.status.toLowerCase(),
                from_support:
                  Data.status.toLowerCase() == "close" ? Data.description : "",
                send_type: Ticketsend.UdsTeam ? 0 : 1,
                support_documents: [],
              }
              imagesFile.forEach((element) => {
                if (element != null) {
                  EditedDATAPresent.support_documents.push(element);
                }
              });


              const payload = {
                formDatas: EditedDATAPresent,
                EditID: EditID,
                currentPage: currentPage,
                selectVal: selectVal,
                white_collar: white_collar,
                from_date: from_date,
                to_date: to_date,
                selectVal: selectVal,
                search: search
              };
              dispatch(setTheTrackingEditionsActions(payload, props.setShow()));
              setPresentUrls([]);


            }
            else if (PresentUrls.length == index + 1 && EditID == "") {

              let CreatedDataPre = {
                // status: Data.status.toLowerCase(),
                user_id: Data.user_id,
                from_user: Data.from_user,
                category_id: Data.category_id,
                request_type: "request",
                // send_type: Ticketsend.UdsTeam ? 0 : 1,
                support_documents: [],
              }
              imagesFile.forEach((element) => {
                CreatedDataPre.support_documents.push(element);
              });

              const payload = {
                formDatas: CreatedDataPre,
                // EditID: EditID,
                currentPage: currentPage,
                selectVal: selectVal,
                white_collar: white_collar,
                // month: Datestate.month,
                search: search,

                // year: Datestate.year,
                // day: Datestate.date,
                from_date: from_date,
                to_date: to_date,

                selectVal: selectVal,
              };
              console.log(CreatedDataPre, "CreatedDataPre8q73423");

              dispatch(setTheTrackingCreateActions(payload, props.setShow()));
              setPresentUrls([]);
            }
          }
        } catch (error) {
          console.error('Error uploading files:', error);
        }
      }));
    };


    if (EditID != "") {



      // formDatas.append(
      //   "data",
      //   JSON.stringify({
      //     status: Data.status.toLowerCase(),
      //     from_support:
      //       Data.status.toLowerCase() == "Close" ? Data.from_support : "",
      //     send_type: Ticketsend.UdsTeam ? 0 : 1,
      //   })
      // );
      let EditedDATA = {
        status: Data.status.toLowerCase(),
        from_support:
          Data.status.toLowerCase() == "close" ? Data.description : "",
        send_type: Ticketsend.UdsTeam ? 0 : 1,
        support_documents: [],

      }
      // imagesFile.forEach((element, index) => {
      //   EditedDATA ={
      //     ...EditedDATA,
      //     [`documents${index}`]: element

      //    }
      // });

      imagesFile.forEach((element) => {
        if (element != null && element != undefined && element != "") {

          EditedDATA.support_documents.push(element);
        }
      });

      if (documentPassed == true) {

        fetchUploadFiles()

      }
      else if (documentPassed === false) {

        const payload = {
          formDatas: EditedDATA,
          EditID: EditID,
          currentPage: currentPage,
          selectVal: selectVal,
          white_collar: white_collar,
          from_date: from_date,
          to_date: to_date,
          selectVal: selectVal,
          search: search
        };
        dispatch(setTheTrackingEditionsActions(payload, props.setShow()));
        setPresentUrls([]);

      }
    } else if (EditID == "") {
      if (Data.category_id == "" || Data.category_id == undefined) {
        setCategoryErr("*Category is requrie");
        a = 1;
      }

      if (a == 0) {

        let CreatedData = {
          // status: Data.status.toLowerCase(),
          user_id: Data.user_id,
          from_user: Data.from_user,
          category_id: Data.category_id,
          request_type: "request",
          // send_type: Ticketsend.UdsTeam ? 0 : 1,
          support_documents: [],
        }

        imagesFile.forEach((element) => {
          if (element != "" && element != undefined && element != null) {

            CreatedData.support_documents.push(element);
          }
        });

        // imagesFile.forEach((element, index) => {
        //   formDatas.append(`document${index}`, element);

        //   CreatedData = {
        //     ...CreatedData,       
        //     [`document${index}`]: element
        //   };

        // });

        if (documentPassed == true) {

          fetchUploadFiles()

        }

        else if (documentPassed === false) {

          const payload = {
            formDatas: CreatedData,
            // EditID: EditID,
            currentPage: currentPage,
            selectVal: selectVal,
            white_collar: white_collar,
            // month: Datestate.month,
            search: search,

            // year: Datestate.year,
            // day: Datestate.date,
            from_date: from_date,
            to_date: to_date,

            selectVal: selectVal,
          };
          dispatch(setTheTrackingCreateActions(payload, props.setShow()));
          setPresentUrls([])

        }
      }
    }
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = "";
      return newImages;
    });
    setInputFields(values);
    const updatedImagesFile = [...imagesFile];

    updatedImagesFile[index] = "";
    setImagesFile(updatedImagesFile);
  };



  const handleAddFields = (index) => {
    if (inputFields.length != 10) {

      const values = [...inputFields];
      values.push({
        Files: "",
        file: "",
      });

      setInputFields(values);
      setImages((prevImages) => {
        const newImages = [...prevImages];
        newImages[index] = "";
        return newImages;
      });

      // const updatedImagesFile = [...imagesFile];

      // updatedImagesFile[forindex] = "";
      // setImagesFile(updatedImagesFile);

      //   setImagesFile(prevUrls => {
      //     const updatedUrls = [...prevUrls];
      //     updatedUrls[forindex] = "";
      //     return updatedUrls;
      // });

    }
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];

    if (event.target.name === "file") {
      setalert(true);
      // images.map((item)=>{
      //   values[index].Files = item;
      // })
      setImageFiles(event)
      //console.log(event.target.files[0], "evefasfsdl");
      setCroppImageViewCount(index);
      setCroppImageView(true);
      setupdatefile(true);



      const file = event.target.files[0];
      const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      const MIN_DIMENSION = 150;

      if (file && allowedTypes.includes(file.type)) {
        if (file.size > maxSize) {
          setCroppImageView(false);
          toast.error("File size exceeds 10MB. Please upload a smaller image.");
        } else {
          const reader = new FileReader();
          reader.addEventListener("load", () => {
            const imageElement = new Image();
            const imageUrl = reader.result?.toString() || "";
            imageElement.src = imageUrl;

            imageElement.addEventListener("load", (imgEvent) => {
              const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

              if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
                toast.error("Image must be at least 150 x 150 pixels.");
                setCroppImageView(false);
                return;
              }
              selectedImage(event, index);
            });
          });
          reader.readAsDataURL(file); // Read the file as a data URL
        }
      } else {
        setCroppImageView(false);
        toast.error("Please upload an image file (jpg, jpeg, png, svg).");
        // e.target.value = ""; // Clear the file input
      }
    }

    setInputFields(values);
  };

  const onImageLoaded = (image) => {
    // imgRef = image;
    imgRef.current = image;
  };

  const selectedImage = (e) => {
    console.log(e.target.files[0], "e.target.files[0]");
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      console.log(imgsrc, "imgsrc");
    }
  };

  const setCompletedCrop = async (c, index) => {
    try {
      // Call getCroppedImg function to get the cropped image data
      const croppedImageUrl = await getCroppedImg(
        imgRef.current,
        c,
        "newfile.jpeg"
      );
      console.log("Cropped image URL:", croppedImageUrl);

      // Update inputFields with the cropped image data
      // const values = [...inputFields];
      // values[index].croppedImageData = croppedImageUrl; // Assuming you have a field for croppedImageData
      // setInputFields(values);
    } catch (error) {
      console.error("Error cropping image:", error);
    } finally {
      setCroppImageView(false); // Close cropping interface
    }
  };

  function getCroppedImg(imageRef, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );


    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        const croppedFile = new File([blob], fileName, {
          type: "image/jpeg",
        });
        var file = croppedFile;
        if (croppedFile) {
          setTimeout(() => {
            setCroppImageView(false)

          }, 0);
        }
        setImageFileChange((prevState) => {
          const newState = [...prevState];
          newState[forindex] = true;
          return newState;
        });

        const valuesFile = [...inputFields]; ///file
        valuesFile[forindex].file = croppedFile; // Assuming you have a field for croppedImageData
        setInputFields(valuesFile);

        const generateRandomNumber = () => {
          return Math.floor(Math.random() * 100000);
        };

        const createPresentData = (croppedFile) => {
          const randomNumber = generateRandomNumber();
          const formattedFilename = `onboarding/tracking/tracking${randomNumber}.${croppedFile.type.split('/')[1]}`; // Use the file's extension
          const Presentdata = {
            multiple_files: [
              {
                filename: formattedFilename,
                file_type: croppedFile.type,
              },
            ],
          };

          return Presentdata;
        };

        const Presentdata = createPresentData(croppedFile);

        setupdatefile(true);

        axios({
          url: PresentUrl,
          method: 'post',
          data: Presentdata,
          headers: {
            Authorization:
              "Bearer " + store.getState().users.UserData.session.token,
          },
        })
          .then((response) => {
            console.log('Files uploaded successfully:', response.data);
            const uploadedFiles = response.data.data;

            const newUrls = uploadedFiles.map(file => ({
              url: file,
              type: croppedFile.type,
              putfiles: croppedFile

            }));

            // Update PresentUrls state
            // setPresentUrls(prevUrls => [...prevUrls, ...newUrls]);
            setPresentUrls(prevUrls => {
              const updatedUrls = [...prevUrls];
              updatedUrls[forindex] = newUrls[0];
              return updatedUrls;
            });



            const updatedImageUrl = String(response.data.data).split("?")[0]
            ////---store the ----certificate ---url 
            const values = [...inputFields]; ///----result
            values[forindex].certificate = String(response.data.data).split("?")[0];
            setInputFields(values);
            //     const updatedImagesFile = [...imagesFile];
            // updatedImagesFile[forindex] = String(response.data.data).split("?")[0];
            // setImagesFile(updatedImagesFile);



            setImagesFile(prevUrls => {
              const updatedUrls = [...prevUrls];
              updatedUrls[forindex] = String(response.data.data).split("?")[0];
              return updatedUrls;
            });

          }).catch((error) => {
            console.error('Error uploading files:', error);
          });

        setdocumentPassed(true);



        var fileBase = croppedFile;
        var reader = new FileReader();
        reader.onloadend = function () {
          setImages((prevImages) => {
            const newImages = [...prevImages];
            newImages[forindex] = reader.result;
            return newImages;
          });

          const values = [...inputFields]; ///----result
          values[forindex].Files = reader.result; // Assuming you have a field for croppedImageData
          setInputFields(values);

          console.log(inputFields, "inputFields");
        };
        reader.readAsDataURL(fileBase);
        //  }

        blob.name = fileName;

        // setCroppImageView(false);




        resolve(croppedFile);
      }, "image/jpeg");
    });
  }

  return (
    <>
      <div className={`${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
        <div className="col BodyContent LeaveEdits">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <span>Trackings  </span>
                      <div
                        className="CloseIcon"
                        onClick={(e) => setShow(false)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>
                    <div className="Modal-Body Modal-bodyTracking">
                      <div className="row">
                        {EditID == "" ? (
                          <div className="col-sm-4 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Name
                            </label>
                            <Select
                              className="Selects"
                              styles={{ position: "relative", top: "60px" }}
                              value={SubRoleList}
                              labelledBy="Select"
                              placeholder={"Search"}
                              isDisabled={true}

                              readOnly={ForReadOnly == 2 ? true : false}
                            />
                          </div>
                        ) : (
                          <div
                            className="col-sm-4  mt-3"
                            style={{ marginTop: "40px" }}
                          >
                            <label for="validationCustom01" class="form-label">
                              Name
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              required
                              autocomplete="off"
                              value={Data.user_name}
                              // readOnly
                              readOnly={ForReadOnly == 2 ? true : false}
                            />
                          </div>
                        )}

                        <div className="col-sm-4 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Description
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="from_user"
                            value={Data.from_user}
                            onChange={(e) => {
                              HandleChanges(e);
                            }}
                            readOnly={EditID == "" ? false : true}

                          // readOnly={ForReadOnly == 2 ? true : false}
                          />
                        </div>

                        <div className="col-sm-4 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Category
                            <span style={{ color: "red" }}>*</span>
                          </label>

                          {EditID != "" ? (
                            <input
                              type="text"
                              class="form-control"
                              required
                              autocomplete="off"
                              value={Data.category_id}
                              name="category_id"
                              // readOnly
                              readOnly={ForReadOnly == 2 ? true : false}
                            />
                          ) : (
                            <Select
                              className="Selects"
                              styles={{ position: "relative", top: "60px" }}
                              options={Category}
                              labelledBy="Select"
                              placeholder={"Search"}
                              onChange={(e) => {
                                if (e != null) {
                                  console.log(e, "category datass");
                                  setCategoryvalue(e);
                                  setCateid({
                                    ...cateid,
                                    id: e.value,
                                  });
                                  // setDatas({
                                  //   ...Data,
                                  //   category_id: e.value,
                                  // });
                                  setCategoryErr("");
                                } else {
                                  setCategoryvalue();
                                  setCategoryErr("");
                                  // setDatas({
                                  //   ...Data,
                                  //   category_id: "",
                                  // });
                                  setCateid({
                                    ...cateid,
                                    id: "",
                                  });
                                }
                              }}
                              value={categoryvalue}
                            />
                          )}
                        </div>
                      </div>

                      <div className="row">
                        {EditID != "" &&
                          state.QueryTrackingrecordgetListRetrieve
                            .QueryTrackingrecordRetrieve != undefined &&
                          state.QueryTrackingrecordgetListRetrieve
                            .QueryTrackingrecordRetrieve.documents != undefined &&
                          state.QueryTrackingrecordgetListRetrieve
                            .QueryTrackingrecordRetrieve.documents != null ? (
                          <div className="col-sm-4 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Documents
                            </label>

                            <>
                              <div
                                className=""
                                // key={index}
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "20px",
                                }}
                              >
                                {state.QueryTrackingrecordgetListRetrieve.QueryTrackingrecordRetrieve.documents.map(
                                  (item, index) => {
                                    return (
                                      <>
                                        {/* <div
                                        className=""
                                        key={index}
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          gap: "20px",
                                        }}
                                      > */}
                                        {item.media_url != null ? (
                                          <div
                                            className="images"
                                            style={{
                                              width: "147px",
                                              height: "135px",
                                            }}
                                          >
                                            <img
                                              src={item.media_url}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                              }}
                                            />
                                          </div>
                                        ) : null}
                                        {/* </div> */}
                                      </>
                                    );
                                  }
                                )}
                              </div>
                            </>
                          </div>
                        ) : null}

                        {
                          // categoryvalue != undefined &&
                          // categoryvalue.value != ""
                          EditID == "" ? (
                            <div className="col-sm-4 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Querys
                              </label>

                              <span style={{ color: "red" }}>*</span>

                              <Select
                                className="Selects"
                                styles={{ position: "relative", top: "60px" }}
                                options={subCateGorys}
                                labelledBy="Select"
                                placeholder={"Search"}
                                onChange={(e) => {
                                  if (e != null) {
                                    console.log(e, "category datass");
                                    setSubCateGorysvalue(e);
                                    setDatas({
                                      ...Data,
                                      category_id: e.value,
                                    });
                                    setCategoryErr("");
                                  } else {
                                    setSubCateGorysvalue();
                                    setCategoryErr("");
                                    setDatas({
                                      ...Data,
                                      category_id: "",
                                    });
                                  }
                                }}
                                value={subCateGorysvalue}
                                isDisabled={ForReadOnly == 2 ? true : false}

                              // readOnly={ForReadOnly == 2 ? true : false}
                              />
                              <p style={{ color: "red" }}>{categoryErr}</p>
                            </div>
                          ) : null
                        }
                        {EditID != "" ?
                          <div className="col-sm-4 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Status
                            </label>
                            {/* <select
                            class="form-select form-select-lg col-12"
                            aria-label=".form-select-lg example"
                            name="status"
                            onChange={(e) => {
                              HandleChanges(e);
                            }}
                            //  value={Data.status}
                          >
                            {Options.map((item) => (
                              <option
                                selected={
                                  EditID != "" &&
                                  Data.status.toLowerCase() ==
                                    item.Status.toLowerCase()
                                }
                                value={item.Status}
                                name="status"
                              >
                                {item.Status}
                              </option>
                            ))}
                          </select> */}

                            <Select
                              className="Selects"
                              styles={{ position: "relative", top: "60px" }}
                              // options={statusotions}
                              isDisabled={ForReadOnly == 2 ? true : false}
                              options={
                                EditID == ""
                                  ? [
                                    {
                                      value: "open",
                                      label: "Open",
                                    },
                                    {
                                      value: "pending",
                                      label: "Pending",
                                    },

                                    // EditID != "" && {
                                    //   value: "close",
                                    //   label: "Close",
                                    // },
                                  ]
                                  : [
                                    {
                                      value: "open",
                                      label: "Open",
                                    },
                                    {
                                      value: "pending",
                                      label: "Pending",
                                    },

                                    {
                                      value: "close",
                                      label: "Close",
                                    },
                                  ]
                              }
                              labelledBy="Select"
                              placeholder={"Select"}
                              onChange={(e) => {
                                if (e != null) {
                                  console.log(e, "category datass");
                                  setStatuslist(e);
                                  setDatas({
                                    ...Data,
                                    status: e.value,
                                  });
                                } else {
                                  setStatuslist();
                                  setDatas({
                                    ...Data,
                                    status: "",
                                  });
                                }
                              }}
                              value={statuslist}
                            />
                          </div>
                          : null}

                        {
                          EditID != "" &&

                            Data.status.toLowerCase() == "open" ? (
                            <div className="col-sm-4 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Ticket Raise To
                              </label>

                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "flex-start",
                                  flexDirection: "row",
                                  marginLeft: "30px",
                                }}
                              >
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "flex-start",
                                    flexDirection: "row",
                                  }}
                                >
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    onChange={(e) =>
                                      handleTicketChanges(
                                        e,
                                        "devTeam ",
                                        true,
                                        false
                                      )
                                    }
                                    checked={Ticketsend.devTeam}

                                    disabled={ForReadOnly == 2 ? true : false}


                                    style={{ cursor: "pointer" }}
                                  />{" "}
                                  Developer Team{" "}
                                </label>

                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                  style={{ width: "100%" }}
                                >
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    onChange={(e) =>
                                      handleTicketChanges(
                                        e,
                                        "UdsTeam",
                                        false,
                                        true
                                      )
                                    }
                                    checked={Ticketsend.UdsTeam}

                                    disabled={ForReadOnly == 2 ? true : false}


                                    style={{ cursor: "pointer" }}
                                  />
                                  UDS Team
                                </label>
                              </div>
                            </div>
                          ) : null
                        }

                        {Data.status.toLowerCase() == "close" ? (
                          <div
                            className="col-sm-3 mt-3"
                            style={{ width: "700px" }}
                          >
                            <label for="validationCustom01" class="form-label">
                              Support
                            </label>
                            <textarea
                              // {/* input */}

                              type="text"
                              class="form-control"
                              required
                              autocomplete="off"
                              name="description"
                              value={Data.description}
                              onChange={HandleDecriptions}
                              style={{ height: "86px" }}
                              readOnly={ForReadOnly == 2 ? true : false}
                            />
                            <p style={{ color: "red" }}>{descpErr}</p>
                          </div>
                        ) : null}
                      </div>

                      {/* <div className="row">
                        <div className="col-6 mt-3">
                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ width: "100%" }}
                          >
                            Documents
                          </label>

                          {inputFields.map((inputField, index) => {
                            console.log(index, "indexserwer", inputField);

                            return (
                              <Fragment key={`${inputField}~${index}`}>
                                <div
                                  className="form-group col-sm-12"
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <div
                                    className=" btn  StatusList"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignContent: "center",
                                      gap: "20px",
                                    }}
                                  >
                                    <button
                                      className="DeclineStatus"
                                      disabled={index === 0}
                                      onClick={() => {
                                        handleRemoveFields(index);
                                      }}
                                    >
                                        <span>
                                            <img src={minus}/>
                                        </span>                                    </button>

                                    <div
                                      className="AddingButton"
                                      onClick={(index) => {
                                        handleAddFields(index);
                                      }}
                                      style={{
                                        backgroundColor: "#F58837",
                                        fontSize: "19px",
                                        width: "  20px",
                                        height: "20px ",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                        <span className="PlusButton">
                                          <img src={PlusIcon}/>
                                        </span>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="col-6"
                                >
                               

                                  <div
                                    className="col-12"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "flex-start",
                                      gap: "10px",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {inputField.Files != undefined && inputField.Files  != null && inputField.Files !=""? 
                                    <img
                                      // src={images[0]}
                                      src={inputField.Files}
                                      // alt="images"
                                      style={{
                                        width: "150px",
                                        height: "150px",
                                        border: "1px solid #000",
                                        borderRadius: "10px",
                                      }}
                                    />
                                    : null }
{ForReadOnly  != 2 ? 
                                    <Button
                                      className="doctorupload"
                                      variant="contained"
                                      component="label"
                                      style={{
                                        background: "#ef4d39",
                                        color: "white",
                                      }}
                                    >

                                      <input
                                        type="file"
                                        hidden
                                        accept="image/png, image/jpeg"
                                        name="file"
                                        onChange={(event) => {
                                          setforindex(index);
                                          handleInputChange(index, event);
                                        }}
                                        ref={fileInputRef}

                                      />Upload Image
                                    </Button>
                                    : null }
                                  </div>

                                </div>
                              </Fragment>
                            );
                          })}
                        </div>
                      </div> */}
                      <div className="col-sm-12 Documentfiled" style={{ marginTop: "20px" }}>
                        <div style={{ display: "flex" }}>

                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ width: "100%" }}
                          >
                            Documents
                          </label>
                        </div>

                        <div style={{ display: "flex" }}>
                          {inputFields.map((inputField, index) => {
                            return (
                              <Fragment key={`${inputField}~${index}`}>
                                <div
                                  className="form-group "
                                  style={{
                                    display: "flex",
                                  }}
                                >
                                  <div
                                    className=" btn  StatusList"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignContent: "center",
                                      gap: "20px",
                                    }}
                                  >

                                    <div
                                      className="col-sm-7"
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "flex-start",
                                        gap: "10px",
                                        flexDirection: "column",
                                      }}
                                    >
                                      {inputField.Files &&
                                        <img
                                          // src={images[0]}
                                          src={inputField.Files}
                                          style={{
                                            width: "150px",
                                            height: "150px",
                                            border: "1px solid #000",
                                            borderRadius: "10px",
                                          }}
                                        />
                                      }

                                      <Button
                                        className="doctorupload"
                                        variant="contained"
                                        component="label"
                                        style={{
                                          background: "#ef4d39", color: "#fff",
                                          fontSize: "11px !important"
                                        }}
                                        isDisabled={ForReadOnly == 2 ? true : false}
                                        readOnly={ForReadOnly == 2 ? true : false}

                                      >

                                        <input
                                          type="file"
                                          hidden
                                          accept="image/png, image/jpeg"
                                          name="file"
                                          // onChange={(e) => handleFiles(e)}
                                          onChange={(event) => {
                                            setforindex(index);
                                            handleInputChange(index, event);
                                          }}
                                          ref={fileInputRef}
                                          disabled={ForReadOnly == 2 ? true : false}

                                        />
                                        Upload Image
                                      </Button>
                                    </div>

                                    <div className="col" style={{ display: "flex", gap: "19px" }}>

                                      <>
                                        <button
                                          className="DeclineStatus"
                                          disabled={index === 0 || ForReadOnly == 2}
                                          onClick={() => {
                                            setforindex(index);

                                            handleRemoveFields(index);
                                          }}
                                        >
                                          <span>
                                            <img src={minus} />
                                          </span>
                                        </button>
                                        {index === 0 ?
                                          // <div
                                          //   className="AddingButton"
                                          //   onClick={(index) => {
                                          //     if(index +1 != 5)
                                          //     handleAddFields(index);
                                          //   }}
                                          //   style={{
                                          //     backgroundColor: "#F58837",
                                          //     fontSize: "19px",
                                          //     width: "  20px",
                                          //     height: "20px ",
                                          //     borderRadius: "50%",
                                          //     display: "flex",
                                          //     alignItems: "center",
                                          //     justifyContent: "center",
                                          //   }}
                                          // >
                                          //   <span className="PlusButton">
                                          //     <img src={PlusIcon} />
                                          //   </span>
                                          // </div>
                                          <div
                                            className="AddingButton"
                                            onClick={() => {
                                              if (inputFields.length < 5) {
                                                handleAddFields();
                                              }
                                            }}
                                            style={{
                                              backgroundColor: "#F58837",
                                              fontSize: "19px",
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "50%",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              cursor: inputFields.length >= 5 || ForReadOnly == 2 ? "not-allowed" : "pointer",

                                            }}

                                          >
                                            <span className="PlusButton">
                                              <img src={PlusIcon} alt="Add" />
                                            </span>
                                          </div>

                                          : null}

                                      </>

                                    </div>


                                  </div>
                                </div>


                              </Fragment>
                            );
                          })}
                        </div>
                      </div>

                    </div>
                    {ForReadOnly != 2 ?

                      <div className="UserButtons">
                        <button
                          class="btn  SaveBtn"
                          type="submit"
                          onClick={(e) => {
                            HandleClick(e);
                          }}
                        // disabled={
                        //   EditID != "" &&
                        //   state.QueryTrackingrecordgetListRetrieve
                        //     .QueryTrackingrecordRetrieve.status ==
                        //     Data.status.toLowerCase()
                        // }
                        >
                          Submit
                        </button>
                        <button
                          class="btn CancelBtn"
                          onClick={(e) => handleClose(e)}
                        >
                          Cancel
                        </button>
                      </div>
                      : null}


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={imageFiles}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCroppImageView(false)}
        />
      )}

    </>
  );
};

export default TrackingRecordApprove;
